const HIDDEN_FILTER_PANEL_SLOT_STYLE = Object.freeze({
    display: 'none',
    flexShrink: 0,
});

const VISIBLE_FILTER_PANEL_SLOT_STYLE = Object.freeze({
    flexShrink: 0,
});

export function getFilterPanelSlotStyle(visible) {
    return visible ? VISIBLE_FILTER_PANEL_SLOT_STYLE : HIDDEN_FILTER_PANEL_SLOT_STYLE;
}
